import React from "react";

const PageNotFound = () => {
    return <React.Fragment>
        <div class="">
            <div className="fixed-background" />
            <main>
                <div className="container w-auto">
                    <div className="">
                        <div >
                            <div className="auth-card w-full">
                                <div className="position-relative image-side ">
                                    <p className="text-white h2">Some error occurred!</p>
                                    <p className="text-white h2">Don't worry, we will fix it soon 🙂</p>
                                    <p className="white mb-0">Yes, it is indeed!</p>

                                    <u className="font-weight-bold underline text-warning h5 cursor-pointer" style={{ cursor: "pointer" }} onClick={() => { window.location.href = ("app/dashboard") }}>
                                        Back to home
                                    </u>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>


        </div>
    </React.Fragment>
}

export default PageNotFound;